module.exports = __webpack_public_path__ + "static/media/uae.2f451056.png";